import Navbar from 'components/views/navbar';

const component = {
  components: {
    navbar: Navbar,
  },
};

export default component;
